import { SupportedCustomPixelEvents } from '@/sources/bundles/wtag-shpfy-cpx/shopify_custom_pixel_types/cpx_event_name_types';
import { CustomPixelStdEventName } from '@/sources/bundles/wtag-shpfy-cpx/shopify_custom_pixel_types/cpx_payload_types';

import { GenericShpyCpxTrigger } from './generic_shpy_cpx_event_triggers';
import {
  CpxPurchaseTrigger,
  ShpyCpxAddToCartTrigger,
  ShpyCpxCheckoutAddressInfoSubmittedTrigger,
  ShpyCpxCheckoutShippingInfoSubmittedTrigger,
  ShpyCpxCheckoutStartedTrigger,
  ShpyCpxCollectionViewedTrigger,
  ShpyCpxFallBackTrigger,
  ShpyCpxPageViewTrigger,
  ShpyCpxPaymentInfoSubmittedTrigger,
  ShpyCpxProductRemovedFromCartTrigger,
  ShpyCpxProductViewedTrigger,
} from './shpy_cpx_event_triggers';

export const ShopifyCustomPixelEventTriggerMap: Record<
  SupportedCustomPixelEvents,
  GenericShpyCpxTrigger
> = {
  [CustomPixelStdEventName.CART_VIEWED]: ShpyCpxFallBackTrigger,
  [CustomPixelStdEventName.CHECKOUT_ADDRESS_INFO_SUBMITTED]:
    ShpyCpxCheckoutAddressInfoSubmittedTrigger,
  [CustomPixelStdEventName.CHECKOUT_COMPLETED]: CpxPurchaseTrigger,
  [CustomPixelStdEventName.CHECKOUT_CONTACT_INFO_SUBMITTED]:
    ShpyCpxCheckoutAddressInfoSubmittedTrigger,
  [CustomPixelStdEventName.CHECKOUT_SHIPPING_INFO_SUBMITTED]:
    ShpyCpxCheckoutShippingInfoSubmittedTrigger,
  [CustomPixelStdEventName.CHECKOUT_STARTED]: ShpyCpxCheckoutStartedTrigger,
  [CustomPixelStdEventName.COLLECTION_VIEWED]: ShpyCpxCollectionViewedTrigger,
  [CustomPixelStdEventName.PAGE_VIEWED]: ShpyCpxPageViewTrigger,
  [CustomPixelStdEventName.PAYMENT_INFO_SUBMITTED]:
    ShpyCpxPaymentInfoSubmittedTrigger,
  [CustomPixelStdEventName.PRODUCT_ADDED_TO_CART]: ShpyCpxAddToCartTrigger,
  [CustomPixelStdEventName.PRODUCT_REMOVED_FROM_CART]:
    ShpyCpxProductRemovedFromCartTrigger,
  [CustomPixelStdEventName.PRODUCT_VIEWED]: ShpyCpxProductViewedTrigger,
  [CustomPixelStdEventName.UNKNOWN_EVENT]: ShpyCpxFallBackTrigger,
};
